import React, {useEffect, useState, useRef} from 'react';
import './StatusBanner.css';
import ResizeObserver from 'react-resize-observer';

interface StatusBannerProps {
  width:number;
  bnParam:any;
  colItem:any;
}

//const JSON5 = require("json5")

export const getBannerParam = (wfBanner:string, PG_BANNER:any, PG_TEXT:any, PG_BORDER:any) => {

  var result = {
    type:1,
    color:'black',
    bgColor:'white',
    bgColor2:'white',
    value:0,
    bwidth:0,
    bcolor:"black",
    btype:'',
    text:'',
    status:'',
    height:"",
    padding:"",
    margin:""
  };

  const wfBn = wfBanner.split(",");
  const hour = parseInt(wfBn[0]);
  const rewarning = parseInt(wfBn[1]);
  result.btype = wfBn[2];
  result.status = wfBn[3];
  const tstatus = wfBn[4];

  result.text = wfBn[5];

  var fontNo = 0;
  var day = Math.floor(hour / 24);
  var bgColor = "white";
  var type = 1;

  if (result.status === 'Completed') {
      if (rewarning>0 && day > rewarning) { // overdue
          fontNo = 4;
      } else {
          fontNo = 3;
      }
      bgColor = PG_BANNER[fontNo].color;
    }
  else {

    if (result.btype==="t" && tstatus==="Completed") {
      if (rewarning>0 && day > rewarning) { // overdue
          fontNo = 4;
      } else {
          fontNo = 3;
      }
      bgColor = PG_BANNER[fontNo].color;
    }
    else
    if (rewarning===0) {
      fontNo = 1;
      bgColor = PG_BANNER[fontNo].color;
    } else
    if (hour > rewarning*24) { // overdue
      fontNo = 2;
      bgColor = PG_BANNER[fontNo].color;
    } else {
      //var w = (hour>=0 ? hour :0) * width / (rewarning * 24);
      var w = (hour>=0 ? hour :0) * 100 / (rewarning * 24);

      result.value = w;
      bgColor = PG_BANNER[0].color;

      result.bgColor2 = PG_BANNER[1].color;
      type = 2;
    }
  }

  result.color = PG_TEXT[fontNo].color;
  result.bgColor = bgColor;
  result.type = type;
  result.bwidth = PG_BORDER.width;
  result.bcolor = PG_BORDER.color;

  return result;
}

const StatusBanner: React.FC<StatusBannerProps> = ({ bnParam, width, colItem }) => {

  var res = bnParam;
  var w = res.value;

  const updateDimensions = async () => {
    //console.log("updateDimensions()");
    const { current } = await refBanner;
    //console.log(current);

    const cur:any = current ? current  : null;

    if (cur) {
      // @ts-ignore: Object is possibly 'null'
      const node = cur._node;
      //console.log("w:"+node.getBoundingClientRect().width);
      var offset,i;
      if (node.getBoundingClientRect().width===0) {
        if (width) {
          setParentWidth(width);
        } else {
          const cnt = node.parentNode.parentNode.childNodes.length;
          offset = 0;
          for(i=0;i<cnt; i++) {
            //const elem = node.parentNode.parentNode.childNodes[i].firstChild.parentElement;
            //console.log(i+":"+elem.nodeType+","+elem.nodeName)
            if (node.parentNode.firstChild !== node.parentNode.parentNode.childNodes[i].firstChild) {
  //                offset += elem.offsetWidth;
                  const eee = node.parentNode.parentNode.childNodes[i].firstChild.firstChild.parentElement;
                  let computedStyle = getComputedStyle(eee);
                  //console.log("  :"+computedStyle.width+","+eee.nodeName+","+eee.offsetWidth+","+eee.clientWidth+","+eee.getBoundingClientRect().width+","+eee.style.pixelWidth+","+eee.style.width+","+eee.width);
                  let pos = computedStyle.width.indexOf("px");
                  let width = parseInt(computedStyle.width.substring(0,pos));
                  offset += (width ? width : 0)+23;
            }
          }
          var grid = node.parentNode.parentNode.parentNode.parentElement;
          if (grid.nodeName!=="ION-GRID") {
            grid = node.parentNode.parentNode.parentNode.parentNode.parentElement;
          }
          //console.log(grid.nodeName+","+grid.getBoundingClientRect().width+","+offset);
          setParentWidth(grid.getBoundingClientRect().width-offset-20);
        }
        return
      }
      
      const cnt = node.parentNode.parentNode.childNodes.length;
      offset = 0;
      for(i=0;i<cnt; i++) {
        const elem = node.parentNode.parentNode.childNodes[i].firstChild.parentElement;
        //console.log(i+":"+elem.nodeName)
        if (node.parentNode.firstChild !== node.parentNode.parentNode.childNodes[i].firstChild) {
          offset += elem.offsetWidth;
        }
      }
      //console.log(node.parentNode.parentNode.parentElement.offsetWidth+","+offset);
      setParentWidth(node.parentNode.parentNode.parentElement.offsetWidth-offset-20);
    }
  }

  useEffect(() => {
    // Your code here
    window.addEventListener('resize', updateDimensions);
  }, []);
  
  if (res.type === 1) {
    w = 100;
  } else {
    w = res.value;
  }

  var ww = 100 - w;

  const [parentWidth, setParentWidth] = useState(1);
  const refBanner = useRef();

  if (res.status!=='Completed' || res.btype==="wf") {
    return (
      <>
      <div 
       ref={async el => {
          if (!el) return;
          //console.log("initial width",el.getBoundingClientRect().width);
          updateDimensions();
  //         const { current } = await refBanner;
  //         console.log(current);

  //         const cur = current ? current  : null;

  //         // @ts-ignore: Object is possibly 'null'
  //         const node = cur._node;
  //         console.log("w:"+node.getBoundingClientRect().width);
  //         if (node.getBoundingClientRect().width==0) {
  //           if (width) {
  //             setParentWidth(width);
  //           } else {
  //             const cnt = node.parentNode.parentNode.childNodes.length;
  //             var offset = 0;
  //             for(var i=0;i<cnt; i++) {
  //               const elem = node.parentNode.parentNode.childNodes[i].firstChild.parentElement;
  //               console.log(i+":"+elem.nodeType+","+elem.nodeName)
  //               if (node.parentNode.firstChild != el.parentNode.parentNode.childNodes[i].firstChild) {
  // //                offset += elem.offsetWidth;
  //                     const eee = node.parentNode.parentNode.childNodes[i].firstChild.firstChild.parentElement;
  //                     let computedStyle = getComputedStyle(eee);
  //                     console.log("  :"+computedStyle.width+","+eee.nodeName+","+eee.offsetWidth+","+eee.clientWidth+","+eee.getBoundingClientRect().width+","+eee.style.pixelWidth+","+eee.style.width+","+eee.width);
  //                     let pos = computedStyle.width.indexOf("px");
  //                     let width = parseInt(computedStyle.width.substring(0,pos));
  //                     offset += width+23;
  //               }
  //             }
  //             const grid = node.parentNode.parentNode.parentNode.parentElement;
  //             //console.log(grid.nodeName+","+grid.getBoundingClientRect().width+","+offset);
  //             setParentWidth(grid.getBoundingClientRect().width-offset-20);
  //           }
  //           return
  //         }
          
  //         const cnt = node.parentNode.parentNode.childNodes.length;
  //         var offset = 0;
  //         for(var i=0;i<cnt; i++) {
  //           const elem = node.parentNode.parentNode.childNodes[i].firstChild.parentElement;
  //           //console.log(i+":"+elem.nodeName)
  //           if (node.parentNode.firstChild != el.parentNode.parentNode.childNodes[i].firstChild) {
  //             offset += elem.offsetWidth;
  //           }
  //         }
  //         console.log(node.parentNode.parentNode.parentElement.offsetWidth+","+offset);
  //         setParentWidth(node.parentNode.parentNode.parentElement.offsetWidth-offset-20);

      //   let prevValue = JSON.stringify(el.getBoundingClientRect());
      //   const start = Date.now();
      //   const handle = setInterval(() => {
      //     let nextValue = JSON.stringify(el.getBoundingClientRect());
      //     if (nextValue === prevValue) {
      //       clearInterval(handle);
      //       if (width) {
      //         setParentWidth(width);
      //       } else {
      //         const cnt = el.parentNode.parentNode.childNodes.length;
      //         var offset = 0;
      //         var maxH = 0;
      //         for(var i=0;i<cnt; i++) {
      //           const elem = el.parentNode.parentNode.childNodes[i].firstChild.parentElement;
      //           //console.log(i+":"+elem.nodeType+","+elem.nodeName)
      //           if (el.parentNode.firstChild != el.parentNode.parentNode.childNodes[i].firstChild) {
      //             offset += elem.offsetWidth;
      //           }
      //           if (elem.offsetHeight > maxH) {
      //             maxH = elem.offsetHeight;
      //           }
      //         }
      //         setParentWidth(el.parentNode.parentNode.parentElement.offsetWidth-offset-20);

      //         // var sumH = 0;
      //         // const cnt2 = el.parentNode.childNodes.length;
      //         // for(var i=0;i<cnt2; i++) {
      //         //   const ch = el.parentNode.children[i] as HTMLScriptElement;
      //         //   //console.log("height item "+i+":"+ch.offsetHeight+" ,"+ch.nodeType+" ,"+ch.nodeName+" ,"+ch.innerHTML);
      //         //   sumH += ch.offsetHeight;
      //         // }
      //         // console.log("H:"+maxH+","+sumH);
      //         // if (sumH > maxH) {
      //         //   maxH = sumH;
      //         // }
      //         // console.log("maxH00:"+maxH);
      //         // el.parentElement.style.height = maxH+"px";

      //         console.log(
      //           `width stopped changing in ${Date.now() - start}ms. final width:`,
      //           el.parentNode.parentElement.getBoundingClientRect().width + " " + el.parentNode.parentNode.parentElement.offsetWidth
      //         );
      //       }
      //     } else {
      //       prevValue = nextValue;
      //     }
      //   }, 100);
      }} 
      
      style={{position:"relative",width:parentWidth,margin:colItem.margin,height:colItem.height}}>
      <span style={{position:"absolute",width:w+"%",top:"0px",left:"0px",display:"inline-block",height:"100%",backgroundColor:res.bgColor}}></span>
      <span style={{position:"absolute",width:ww+"%",top:"0px",left:w+"%",display:"inline-block",height:"100%",backgroundColor:res.bgColor2}}></span>
      <span style={{borderStyle:'solid',borderColor:res.bcolor,borderWidth:res.bwidth,position:"absolute",width:"100%",top:"0px",left:"0px",display:"inline-block",height:"100%",color:res.color,padding:colItem.padding}}>{res.text}</span>
      </div>
      <ResizeObserver ref={refBanner}
        onResize={(rect) => {
          //console.log('Resized 1. New bounds:', rect.width, 'x', rect.height);
        }}

        onPosition={(rect) => {
          //console.log('Moved 1. New position:', rect.left, 'x', rect.top);
        }}/>
      </>
    );
  } else {
    return <></>
  }
};

export default StatusBanner;
